import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
// components
import RMDRImage from "@/components/RMDRImage";
//interfaces
import TClientSiteSettingDetail from "@/cms/types/TClientSiteSettingDetail";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";
//
import './style.scss';
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const mapStateToProps = ( state:any ) => {
    console.log("Preloader.mapStateToProps: ", state);

    const siteSettingsPayload:TClientSiteSettingDetail|null = state.SiteSettingStore.details.payload;
    
    const isLoading = !state.CoreStore.loader.isLoading;

    return {

        siteSettingsPayload,

        isLoading
    
    }
}

const connector = connect(mapStateToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>


/* component */
const Preloader = ( props:PropsFromRedux ) => {
    console.log("Preloader.rendered: ", props);

    const [ preloaderCSS, setPreloaderCSS ] = useState("");
    const [ showPreloader, setShowPreloader ] = useState(false);

    const languageVersion = outerNameDescriptionLanguageVersion(props.siteSettingsPayload?.languageVersions);

    useEffect (
        () => {
            if ( props.isLoading === false ) {
                setTimeout( () => { setPreloaderCSS("animate__fadeOut"); }, 400 );
                setTimeout( () => { setShowPreloader(false); }, 600 );
            }
            else {
                setPreloaderCSS("");
                setShowPreloader(true);
            }
        }, [props.isLoading]
    )
    
    if ( showPreloader ) {
        document.body.classList.add('overflow-hidden');

        return (
            <div className={`rmdr-preloader animate__animated animate__faster ${preloaderCSS}`}>
                <div className="loader-circle"></div>
                <div className="loader-line-mask">
                    <div className="loader-line"></div>
                </div>
                <RMDRImage
                    resources={props.siteSettingsPayload?.resources}
                    resourceType={EResourceType.LOGO_ONLY}
                    sizeType={ESizeType.X02}
                    alt={languageVersion?.name}
                    title={languageVersion?.name}
                />
            </div>
        )
    }

    document.body.classList.remove('overflow-hidden');
    return null;

}

const Component = React.memo(Preloader, ( prevProps:PropsFromRedux, nextProps:PropsFromRedux ) => {
    console.log("Preloader.memo", { prevProps, nextProps });
    return !( 
        prevProps.isLoading !== nextProps.isLoading
        || prevProps.siteSettingsPayload !== nextProps.siteSettingsPayload
    );
});

export default connector(Component);
